import SBPhoneInput from '@modules/sb-antd-phone-input/SBPhoneInput'
import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { formatPhoneNumberToE164FromPhoneInput } from '@utils/PhoneFormatter'
import { isE164Phone, requiredRule } from '@utils/rules'
import { Flex, Form } from 'antd'
import { NamePath } from 'antd/es/form/interface'

interface PhoneNumberSectionProps {}

const PhoneNumberSection = ({}: PhoneNumberSectionProps) => {
  const venue = useAppSelector(selectSelectedVenue())
  const formItemName: NamePath = ['booking', 'app', 'connectors', 'phone']

  if (!venue) return <></>

  return (
    <Flex vertical style={{ padding: 20 }} gap={20}>
      <Form.Item
        name={formItemName}
        label={'Phone number'}
        rules={[requiredRule(), isE164Phone()]}
        getValueFromEvent={(args: any) => {
          return formatPhoneNumberToE164FromPhoneInput(args)
        }}
      >
        <SBPhoneInput
          disableParentheses
          enableSearch
          size="large"
          sbInitialValue={venue.booking.app.connectors.phone}
        />
      </Form.Item>
    </Flex>
  )
}

export { PhoneNumberSection }
